<div class="modal-header">
    <h4 class="modal-title">
        Work Order Details
        @if (workOrder) {
            <span> — {{ workOrder }}</span>
        }
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    @if (equipmentSummary) {
        <div class="wo-details-equipment-summary">
            <strong>{{ equipmentSummary.equipment }}</strong>
            @if (equipmentSummary.description) {
                <span> — {{ equipmentSummary.description }}</span>
            }
            @if (equipmentSummary.category) {
                <span class="text-muted"> · {{ equipmentSummary.category }}</span>
            }
            @if (equipmentSummary.hourReading != null) {
                <span class="text-muted"> · Hours {{ equipmentSummary.hourReading }}</span>
            }
            @if (equipmentSummary.odoReading != null) {
                <span class="text-muted"> · Odo {{ equipmentSummary.odoReading }}</span>
            }
            @if (equipmentSummary.lastCompletedWorkOrderDate || equipmentSummary.lastCompletedWorkOrderNumber) {
                <span class="text-muted">
                    · Last completed
                    @if (equipmentSummary.lastCompletedWorkOrderDate) {
                        <span>{{ equipmentSummary.lastCompletedWorkOrderDate | date: 'MM/dd/yyyy' }}</span>
                    }
                    @if (equipmentSummary.lastCompletedWorkOrderNumber) {
                        <span> (WO {{ equipmentSummary.lastCompletedWorkOrderNumber }})</span>
                    }
                </span>
            }
        </div>
    }
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" (navChange)="onNavChange($event)" class="nav-tabs wo-group-nav">
        <li [ngbNavItem]="'workOrder'" [destroyOnHide]="false">
            <a ngbNavLink>Work Order</a>
            <ng-template ngbNavContent>
                <div class="wo-workspace" [class.wo-workspace-stacked]="isMobileLayout()">
                    <div class="wo-workspace-history">
                        <h5 class="wo-pane-title">History</h5>
                        <app-work-order-history
                            [equipment]="equipmentId"
                            [showSummary]="false"
                            [fillHeight]="true"
                            [selectedWorkOrder]="workOrder"
                            [selectedWebAppsId]="workOrderId"
                            (openWorkOrder)="openFromHistory($event)"
                        ></app-work-order-history>
                    </div>
                    <div class="wo-workspace-details">
                        <div class="wo-pane wo-pane-items">
                            <h5 class="wo-pane-title">Items</h5>
                            @if (isLoadingItems) {
                                <div class="text-center py-4">
                                    <div class="spinner-border text-primary mb-3" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    <p class="text-muted mb-0">Loading work order items...</p>
                                </div>
                            } @else {
                                <div class="row action-toolbar wo-pane-toolbar">
                                    <div class="col-12">
                                        <form class="form-inline">
                                            <action-toolbar-count [grid]="itemsGrid"></action-toolbar-count>
                                            <action-toolbar-search name="itemsSearch" [(ngModel)]="itemsGrid.filter"></action-toolbar-search>
                                        </form>
                                    </div>
                                </div>
                                <div class="wo-grid-host">
                                    <wj-flex-grid
                                        #itemsGridFlexGrid
                                        class="wo-fill-grid"
                                        (initialized)="initializeItemsGrid(itemsGridFlexGrid)"
                                        (destroy)="itemsGrid.destroy()"
                                        [itemsSource]="itemsGrid.view"
                                    >
                                        <wj-flex-grid-filter></wj-flex-grid-filter>
                                        <wj-flex-grid-column [header]="'Item #'" [binding]="'woitem'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Description'"
                                            [binding]="'description'"
                                            [width]="'*'"
                                            [minWidth]="180"
                                            [isReadOnly]="true"
                                            [cssClass]="'wo-item-desc-cell'"
                                        >
                                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                                <span class="wo-item-desc" [title]="cell.item.description">{{ cell.item.description }}</span>
                                            </ng-template>
                                        </wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Status'"
                                            [binding]="'statusCode'"
                                            [width]="90"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Repair Type'"
                                            [binding]="'repairType'"
                                            [width]="110"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Cost Code'"
                                            [binding]="'costCode'"
                                            [width]="100"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Priority'"
                                            [binding]="'priority'"
                                            [width]="80"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Date Created'"
                                            [binding]="'dateCreated'"
                                            [width]="110"
                                            [format]="'d'"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Date Due'"
                                            [binding]="'dateDue'"
                                            [width]="110"
                                            [format]="'d'"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Date Scheduled'"
                                            [binding]="'dateSched'"
                                            [width]="120"
                                            [format]="'d'"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                        <wj-flex-grid-column
                                            [header]="'Notes'"
                                            [binding]="'notes'"
                                            [width]="'*'"
                                            [minWidth]="140"
                                            [isReadOnly]="true"
                                        ></wj-flex-grid-column>
                                    </wj-flex-grid>
                                </div>
                            }
                        </div>
                        <div class="wo-pane wo-pane-notes">
                            <h5 class="wo-pane-title">Notes</h5>
                            <div class="wo-notes-pane">
                                @if (isLoadingNotes) {
                                    <div class="text-center py-4">
                                        <div class="spinner-border text-primary mb-3" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        <p class="text-muted mb-0">Loading mechanic notes...</p>
                                    </div>
                                } @else if (notes) {
                                    <div class="d-flex flex-wrap align-items-center gap-3 mb-2">
                                        <strong>Total hours: {{ notes.totalHours | number: '1.1-1' }}</strong>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm wo-notes-filter"
                                            name="notesFilter"
                                            [(ngModel)]="notesFilter"
                                            placeholder="Search notes"
                                        />
                                    </div>

                                    @if (notes.timeCardLookupSkipped) {
                                        <p class="text-muted">
                                            Time-card notes are not available until this work order is synced to Vista.
                                        </p>
                                    }

                                    @if (notes.headerNotes) {
                                        <h6>Work order notes</h6>
                                        <pre class="wo-header-notes">{{ notes.headerNotes }}</pre>
                                    }

                                    @for (group of visibleNoteGroups; track group.woitem + ':' + group.description) {
                                        <section class="wo-notes-item">
                                            <h6>
                                                Item {{ group.woitem }} — {{ group.description || 'Item ' + group.woitem }}
                                                <span class="text-muted">({{ group.hours | number: '1.1-1' }} hrs)</span>
                                                @if (group.dateCompleted) {
                                                    <span class="text-muted"> · Completed {{ group.dateCompleted | date: 'MM/dd/yyyy' }}</span>
                                                }
                                            </h6>
                                            @if (group.itemNotes) {
                                                <p class="text-muted wo-item-notes">{{ group.itemNotes }}</p>
                                            }
                                            @for (memo of group.timeCardNotes; track $index) {
                                                <div class="wo-memo">
                                                    <div class="wo-memo-meta">
                                                        {{ memo.postDate | date: 'MM/dd/yyyy' }} —
                                                        {{ memo.employeeName || memo.employee }} —
                                                        {{ memo.hours | number: '1.1-1' }} hrs
                                                    </div>
                                                    <div class="wo-memo-text">{{ memo.memo }}</div>
                                                </div>
                                            }
                                        </section>
                                    }

                                    @if (notesAreCapped) {
                                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="showAllNotes = true">
                                            Showing {{ notesCap }} of {{ totalFilteredMemoCount }} notes. Show all
                                        </button>
                                    }

                                    @if (!notes.headerNotes && visibleNoteGroups.length === 0 && !notes.timeCardLookupSkipped) {
                                        <p class="text-muted mb-0">No notes found for this work order.</p>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'equipment'" [destroyOnHide]="false">
            <a ngbNavLink>Equipment</a>
            <ng-template ngbNavContent>
                <div class="wo-equipment-pane">
                    <ul ngbNav #equipmentNav="ngbNav" [(activeId)]="equipmentActive" (navChange)="onEquipmentNavChange()" class="nav-tabs">
                        <li [ngbNavItem]="'details'" [destroyOnHide]="false">
                            <a ngbNavLink>Details</a>
                            <ng-template ngbNavContent>
                                <div class="wo-equipment-section">
                                    <div class="wo-grid-host">
                                        <wj-flex-grid
                                            #metersGridFlexGrid
                                            class="wo-fill-grid"
                                            (initialized)="metersGrid.initialize(metersGridFlexGrid)"
                                            (destroy)="metersGrid.destroy()"
                                            [itemsSource]="metersGrid.view"
                                        >
                                            <wj-flex-grid-filter></wj-flex-grid-filter>
                                            <wj-flex-grid-column
                                                [header]="'Equipment'"
                                                [binding]="'equipment'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Description'"
                                                [binding]="'equipmentDescription'"
                                                [width]="'*'"
                                                [minWidth]="350"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Main Category'"
                                                [binding]="'mainCategory'"
                                                [width]="275"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Sub Category'"
                                                [binding]="'category'"
                                                [width]="275"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Category Code'"
                                                [binding]="'categoryCode'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Job'"
                                                [binding]="'job'"
                                                [width]="'*'"
                                                [minWidth]="200"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Project Manager'"
                                                [binding]="'projectManagerName'"
                                                [width]="150"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Super'"
                                                [binding]="'superName'"
                                                [width]="150"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Location'"
                                                [binding]="'location'"
                                                [width]="150"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Manufacturer'"
                                                [binding]="'manufacturer'"
                                                [width]="150"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Model'" [binding]="'model'" [width]="150" [isReadOnly]="true"></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Model Year'"
                                                [binding]="'modelYr'"
                                                [width]="100"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Total Hour Meter'"
                                                [binding]="'totalHourMeter'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Total Odometer'"
                                                [binding]="'totalOdometer'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Current Hour Meter'"
                                                [binding]="'currentHourMeter'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Current Odometer'"
                                                [binding]="'currentOdometer'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Hour Reading'"
                                                [binding]="'hourReading'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Hour Date'"
                                                [binding]="'hourDate'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Odo Reading'"
                                                [binding]="'odoReading'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Odo Date'"
                                                [binding]="'odoDate'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                        </wj-flex-grid>
                                    </div>
                                </div>
                            </ng-template>
                        </li>

                        <li [ngbNavItem]="'warranty'" [destroyOnHide]="false">
                            <a ngbNavLink>Warranty</a>
                            <ng-template ngbNavContent>
                                <div class="wo-equipment-section">
                                    <div class="wo-grid-host">
                                        <wj-flex-grid
                                            #warrantyGridFlexGrid
                                            class="wo-fill-grid"
                                            (initialized)="warrantyGrid.initialize(warrantyGridFlexGrid)"
                                            (destroy)="warrantyGrid.destroy()"
                                            [itemsSource]="warrantyGrid.view"
                                        >
                                            <wj-flex-grid-filter></wj-flex-grid-filter>
                                            <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty'" [binding]="'warrantyDescription'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty Miles'" [binding]="'warrantyMiles'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty Hours'" [binding]="'warrantyHours'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty Days'" [binding]="'warrantyDays'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty Months'" [binding]="'warrantyMonths'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty Years'" [binding]="'warrantyYears'" [width]="150"></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Warranty Start Date'"
                                                [binding]="'warrantyStartDate'"
                                                [width]="150"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Warranty End Date'"
                                                [binding]="'warrantyEndDate'"
                                                [width]="150"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Warranty Status'" [binding]="'warrantyStatus'" [width]="150"></wj-flex-grid-column>
                                        </wj-flex-grid>
                                    </div>
                                </div>
                            </ng-template>
                        </li>

                        <li [ngbNavItem]="'parts'" [destroyOnHide]="false">
                            <a ngbNavLink>Parts & Fluids</a>
                            <ng-template ngbNavContent>
                                <div class="wo-equipment-section">
                                    @if (canViewPurchaseOrders) {
                                        <h6>Purchase Orders for this work order</h6>
                                        @if (purchaseOrders.length === 0) {
                                            <p class="text-muted">No purchase orders linked to this work order yet.</p>
                                        } @else {
                                            <table class="table table-sm table-striped wo-po-table mb-3">
                                                <thead>
                                                    <tr>
                                                        <th>PO Number</th>
                                                        <th>Vendor</th>
                                                        <th>Status</th>
                                                        <th>Lines</th>
                                                        <th>Total</th>
                                                        <th>Receipts</th>
                                                        <th>Created</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (po of purchaseOrders; track po.id) {
                                                        <tr>
                                                            <td>
                                                                <a [routerLink]="['/purchasing/purchase-orders']" (click)="cancel()">{{ po.poNumber }}</a>
                                                            </td>
                                                            <td>{{ po.vendorName }}</td>
                                                            <td>{{ po.status }}</td>
                                                            <td>{{ po.lineCount }}</td>
                                                            <td>{{ po.total == null ? '' : (po.total | currency) }}</td>
                                                            <td>{{ po.receiptCount }}</td>
                                                            <td>{{ po.createdOn | date: 'short' }}</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        }
                                    }

                                    <div class="row action-toolbar wo-pane-toolbar">
                                        <div class="col-12">
                                            <form class="form-inline">
                                                <action-toolbar-count [grid]="partsGrid"></action-toolbar-count>
                                                <action-toolbar-search name="partsSearch" [(ngModel)]="partsGrid.filter"></action-toolbar-search>
                                                <input
                                                    type="text"
                                                    class="form-control catalog-search-input"
                                                    name="catalogSearch"
                                                    [(ngModel)]="catalogSearch"
                                                    placeholder="Search catalog"
                                                    (keyup.enter)="searchCatalog()"
                                                />
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-secondary btn-sm"
                                                    (click)="searchCatalog()"
                                                    [disabled]="isSearchingCatalog"
                                                >
                                                    Search catalog
                                                </button>
                                                @if (canCreatePurchaseOrders) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-primary btn-sm"
                                                        (click)="openCreatePurchaseOrder()"
                                                        [disabled]="selectedParts.length === 0"
                                                    >
                                                        Create Purchase Order ({{ selectedParts.length }})
                                                    </button>
                                                }
                                            </form>
                                        </div>
                                    </div>

                                    <div class="wo-grid-host">
                                        <wj-flex-grid
                                            #partsGridFlexGrid
                                            class="wo-fill-grid"
                                            (initialized)="partsGrid.initialize(partsGridFlexGrid)"
                                            (destroy)="partsGrid.destroy()"
                                            (cellEditEnded)="onPartsEdited()"
                                            [itemsSource]="partsGrid.view"
                                        >
                                            <wj-flex-grid-filter></wj-flex-grid-filter>
                                            <wj-flex-grid-column [header]="'Select'" [binding]="'selected'" [width]="80" [align]="'center'" [isReadOnly]="true">
                                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                                    {{ cell.col.header }}<br />
                                                    <input id="selectAllParts" type="checkbox" (change)="toggleAllSelected($event)" />
                                                </ng-template>
                                                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                                    <input
                                                        type="checkbox"
                                                        [checked]="cell.item.selected"
                                                        (mousedown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()"
                                                        (change)="togglePartSelected(cell.item, $event)"
                                                    />
                                                </ng-template>
                                            </wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Source'" [binding]="'source'" [width]="100" [isReadOnly]="true">
                                                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                                    <span
                                                        class="pf-source-badge"
                                                        [class.pf-source-vista]="cell.item.source === 'Vista'"
                                                        [class.pf-source-webapps]="cell.item.source === 'WebApps'"
                                                    >
                                                        {{ cell.item.source }}
                                                    </span>
                                                </ng-template>
                                            </wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Category'"
                                                [binding]="'category'"
                                                [width]="110"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Sub-Category'"
                                                [binding]="'subCategory'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Item'"
                                                [binding]="'itemLabel'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Value'"
                                                [binding]="'itemValue'"
                                                [width]="150"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Equipment'"
                                                [binding]="'equipment'"
                                                [width]="120"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Qty'" [binding]="'quantity'" [width]="70" [isReadOnly]="true"></wj-flex-grid-column>
                                            <wj-flex-grid-column [header]="'Unit'" [binding]="'um'" [width]="70" [isReadOnly]="true"></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Suggested Vendor'"
                                                [binding]="'suggestedVendor'"
                                                [width]="130"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Unit Cost'"
                                                [binding]="'unitCost'"
                                                [width]="100"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                            <wj-flex-grid-column
                                                [header]="'Details'"
                                                [binding]="'details'"
                                                [width]="'*'"
                                                [isReadOnly]="true"
                                            ></wj-flex-grid-column>
                                        </wj-flex-grid>
                                    </div>
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                    <div class="wo-equipment-outlet" [ngbNavOutlet]="equipmentNav"></div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div class="wo-nav-outlet" [ngbNavOutlet]="nav"></div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>
</div>
